<template>
  <div class="home flex justify-center">
    <div class="container" v-if="pageSettings">
      <MainBanner
        :type="getOptionByKey('featured_block').value"
        :value="
          getOptionByKey('featured_block').value == 'video'
            ? getOptionByKey('featured_video').value
            : getOptionByKey('featured_image').value
        "
      />
      <div class="mt-4">
        <!-- <TodaySelection /> -->
        <FeaturedCategories
          :categories="getOptionByKey('featured_categories').value"
        />
        <FeaturedStars />
        <TopCategories :categories="getOptionByKey('top_categories').value" />
        <NewsletterBlock />
      </div>
    </div>
  </div>
</template>

<script>
import MainBanner from "./components/MainBanner";
// import TodaySelection from "./components/TodaySelection";
import FeaturedCategories from "./components/FeaturedCategories";
import FeaturedStars from "@/components/layout/Stars/FeaturedStars";
import TopCategories from "./components/TopCategories";
import NewsletterBlock from "./components/NewsletterBlock";
export default {
  name: "HomeView",
  components: {
    MainBanner,
    // TodaySelection,
    FeaturedCategories,
    FeaturedStars,
    TopCategories,
    NewsletterBlock,
  },
  computed: {
    pageSettings() {
      return this.$store.getters["pageSettings/settings"]["Homepage"] ?? null;
    },
  },
  watch: {
    pageSettings() {
      if (!this.pageSettings) {
        return;
      }
      this.setMeta(this.pageSettings.title, this.pageSettings.description);
    },
  },
  mounted() {
    if (!this.pageSettings) {
      return;
    }
    this.setMeta(this.pageSettings.title, this.pageSettings.description);
  },
  methods: {
    setMeta(title, description) {
      document.title = title;
      const metaDescription = document.querySelector(
        'head meta[name="description"]'
      );
      metaDescription.setAttribute("content", description);
    },
    getOptionByKey(key) {
      return this.pageSettings.options.find((item) => item.key === key);
    },
  },
};
</script>
